'use client';

import { Suspense, useState } from 'react';
import dynamic from 'next/dynamic';
import { type FleetCategoryImageGalleryProps } from '@/components/FleetCategory/FleetCategoryImageGallery';
import { Modal } from '@/components/Modal';
import analytics from '@/services/analytics';
import type { AnalyticsInteractionEventParams } from '@/services/analytics/plugins/analyticsJucyInteraction';

const FleetCategoryImageGallery = dynamic(() => import('@/components/FleetCategory/FleetCategoryImageGallery').then((mod) => mod.FleetCategoryImageGallery));

export interface FleetCategoryImageGalleryModalProps extends FleetCategoryImageGalleryProps {
    buttonLabel?: string;
    trackInteraction?: AnalyticsInteractionEventParams;
}
export function FleetCategoryImageGalleryModalBtn({ buttonLabel = 'Image gallery', className, trackInteraction, ...props }: FleetCategoryImageGalleryModalProps) {
    const [open, setOpen] = useState(false);

    return (
        <>
            <button
                className={className}
                onClick={() => {
                    analytics.plugins.interactions.trackInteraction({
                        source: trackInteraction?.source || 'jucy-website',
                        category: trackInteraction?.category || 'image-gallery',
                        action: trackInteraction?.action || 'click',
                        label: trackInteraction?.label || buttonLabel,
                    });
                    setOpen(true);
                }}
                data-testid="fleet-category-image-gallery-modal-btn "
            >
                {buttonLabel}
            </button>
            <Modal
                className="[&_.modal-box]:p-0 [&_.modal-box]:mx-8 [&_.modal-box]:max-h-[calc(100dvh-1rem)] [&_.modal-box]:max-w-[calc(100%-1rem)] [&_.modal-box]:wide:max-w-wide [&_.modal-box]:bg-black"
                open={open}
                onClose={() => setOpen(false)}
                showClose={true}
                data-testid="fleet-category-image-gallery-modal"
            >
                <Suspense>{open ? <FleetCategoryImageGallery {...props} className="[&_.btn-prev]:left-3 [&_.btn-next]:right-3  h-[calc(100vh-1rem)] md:h-auto" /> : null}</Suspense>
            </Modal>
        </>
    );
}
